export interface AdminArticle {
  id: number;
  title: string;
  category: string;
  status: 'Yayında' | 'Taslak';
  publishDate: string;
  image: string;
}

export const adminArticles: AdminArticle[] = [
  { id: 1, title: 'Sağlıklı Bir İlişkinin 7 Temel Taşı', category: 'İlişkiler', status: 'Yayında', publishDate: '15.03.2026', image: '' },
  { id: 2, title: 'Aile İçi Çatışmaları Çözmenin Etkili Yolları', category: 'Aile', status: 'Yayında', publishDate: '08.03.2026', image: '' },
  { id: 3, title: 'Ergenlik Döneminde Ebeveyn Olmak', category: 'Çocuk & Ergen', status: 'Yayında', publishDate: '01.03.2026', image: '' },
  { id: 4, title: 'Kaygı ile Başa Çıkmanın Psikolojik Yolları', category: 'Psikoloji', status: 'Taslak', publishDate: '22.02.2026', image: '' },
  { id: 5, title: 'Evlilik Krizlerini Fırsata Dönüştürmek', category: 'İlişkiler', status: 'Yayında', publishDate: '14.02.2026', image: '' },
];

export interface AdminTestimonial {
  id: number;
  name: string;
  comment: string;
  rating: number;
  service: string;
  status: 'Aktif' | 'Gizli';
}

export const adminTestimonials: AdminTestimonial[] = [
  { id: 1, name: 'Selin K.', comment: 'Ayşegül Hanım ile çalışmak hayatımı gerçekten değiştirdi.', rating: 5, service: 'Çift Danışmanlığı', status: 'Aktif' },
  { id: 2, name: 'Mehmet ve Aylin T.', comment: 'İlk seans öncesi çok tedirgin ve şüpheciydik.', rating: 5, service: 'Aile Terapisi', status: 'Aktif' },
  { id: 3, name: 'Zeynep B.', comment: 'Bireysel danışmanlık sürecimde kendimi gerçekten güvende hissettim.', rating: 5, service: 'Bireysel Danışmanlık', status: 'Aktif' },
  { id: 4, name: 'Caner Ö.', comment: 'Oğlumun ergenlik dönemindeki zorluklarını aşmasında büyük yardımı oldu.', rating: 5, service: 'Çocuk & Ergen', status: 'Aktif' },
];

export interface AdminAppointment {
  id: number;
  name: string;
  phone: string;
  topic: string;
  date: string;
  time: string;
  type: 'Online' | 'Yüz yüze';
  status: 'Yeni' | 'İletişime Geçildi' | 'Tamamlandı';
}

export const adminAppointments: AdminAppointment[] = [
  { id: 1, name: 'Elif Yıldız', phone: '0532 111 2233', topic: 'Aile Terapisi', date: '27.03.2026', time: '10:00', type: 'Online', status: 'Yeni' },
  { id: 2, name: 'Burak Arslan', phone: '0545 444 5566', topic: 'Çift Danışmanlığı', date: '28.03.2026', time: '14:00', type: 'Yüz yüze', status: 'İletişime Geçildi' },
  { id: 3, name: 'Merve Demir', phone: '0507 777 8899', topic: 'Bireysel Danışmanlık', date: '29.03.2026', time: '11:00', type: 'Online', status: 'Yeni' },
  { id: 4, name: 'Hasan Kaya', phone: '0530 222 3344', topic: 'Çocuk Danışmanlığı', date: '25.03.2026', time: '15:30', type: 'Yüz yüze', status: 'Tamamlandı' },
  { id: 5, name: 'Rana Şahin', phone: '0543 555 6677', topic: 'Boşanma Süreci', date: '26.03.2026', time: '09:00', type: 'Online', status: 'İletişime Geçildi' },
];